var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlpha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.013 1v11.225l-2.035 5.055 2.035-1.707v5.383l-.066.066A39.765 39.765 0 0 1 4 31L16.013 1zm0 0v11.225l2.036 5.055-2.036-1.707v5.383l.065.066A39.765 39.765 0 0 0 28.026 31L16.014 1zm2.758 24.157a2.757 2.757 0 1 1-5.513 0 2.757 2.757 0 0 1 5.514 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpha);
export default __webpack_public_path__ + "static/media/ALPHA.0c59036f70767788bc1565052bed18b7.svg";
export { ForwardRef as ReactComponent };